import { CheckgridsView } from "@/react/components/entityViews/checkgrids/CheckgridsView";

export const CheckgridsPage = () => {
  return (
    <div
      className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0"
      id="checkgrids-page"
    >
      <div className="flex-1 min-h-0">
        <CheckgridsView />
      </div>
    </div>
  );
};

export default CheckgridsPage;
